import { Outlet } from "react-router";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { useAppStore } from "@/lib/store";
import { cn } from "@/lib/cn";

export function AppLayout() {
  const sidebarCollapsed = useAppStore((s) => s.sidebarCollapsed);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Sidebar - hidden on mobile by default, toggled via overlay */}
      <div
        className={cn(
          "hidden flex-shrink-0 md:flex transition-all duration-300",
          sidebarCollapsed ? "w-16" : "w-64",
        )}
      >
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      <MobileSidebar />

      {/* Main area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <div className="animate-page-in p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

function MobileSidebar() {
  const sidebarCollapsed = useAppStore((s) => s.sidebarCollapsed);
  const setSidebarCollapsed = useAppStore((s) => s.setSidebarCollapsed);

  // On mobile, "collapsed" means hidden; toggling opens an overlay
  if (sidebarCollapsed) return null;

  return (
    <div className="fixed inset-0 z-40 md:hidden">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => setSidebarCollapsed(true)}
      />
      {/* Sidebar panel */}
      <div className="relative z-50 h-full w-64 shadow-2xl">
        <Sidebar />
      </div>
    </div>
  );
}
